import * as form from '../form';

export const financialForeclosure = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        EntityType: form.radio(xitem.EntityType),
        EntityTypeExplain: form.textarea(xitem.EntityTypeExplain),
        EntityName: form.text(xitem.EntityName),
        PrivateName: form.name(xitem.PrivateName),
        PropertyType: form.radio(xitem.PropertyType),
        PropertyTypeExplain: form.textarea(xitem.PropertyTypeExplain),
        PropertyLocation: form.location(xitem.PropertyLocation),
        FirstPastDue: form.datecontrol(xitem.FirstPastDue),
        NumberMissed: form.text(xitem.NumberMissed),
        NumberMissedEstimated: form.checkbox(xitem.NumberMissedEstimated),
        AmountOwed: form.number(xitem.AmountOwed),
        AmountOwedEstimated: form.checkbox(xitem.NumberMissedEstimated),
        Why: form.textarea(xitem.Why),
        When: form.datecontrol(xitem.When),
        Current: form.branch(xitem.Current),
        WhenResolved: form.datecontrol(xitem.WhenResolved),
        ActionsTaken: form.textarea(xitem.ActionsTaken),
        ActionsTakenNone: form.notapplicable(xitem.ActionsTakenNone),
        ActionsTakenReason: form.textarea(xitem.ActionsTakenReason),
        CourtName: form.text(xitem.CourtName),
        CourtNameNotApplicable: form.notapplicable(xitem.CourtNameNotApplicable),
        CourtLocation: form.location(xitem.CourtLocation),
        CourtLocationNotApplicable: form.notapplicable(xitem.CourtLocationNotApplicable),
        OrderNum: form.text(xitem.OrderNum),
        OrderNumIdk: form.notapplicable(xitem.OrderNumIdk),
      },
    };
  });
  return {
    HasForeclosure: form.branch(data.HasForeclosure),
    List: form.collection(items, (data.List || {}).branch),
  };
};
